<template>
  <v-container fluid class="grey lighten-3">

    <v-row class="inner-content">
      <v-col>
        <AssignmentsTable />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: 'Assignments',

  components: {
    AssignmentsTable: () => import('@/components/tables/AssignmentsTable.vue')
  },
}
</script>
